import { render, staticRenderFns } from "./TutorBreakCardActiveBreak.vue?vue&type=template&id=b54fbb54&"
import script from "./TutorBreakCardActiveBreak.vue?vue&type=script&lang=js&"
export * from "./TutorBreakCardActiveBreak.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports